import React from 'react';
import TrackerPage from '../components/TrackerPage';
import useTrackerAccess from '../hooks/useTrackerAccess';
import { CARD, VIEWS } from '../utils/trackerConstants';

const CARDS = [CARD.total, CARD.unassigned, CARD.awaitingTutor, CARD.newTutorAssigned, CARD.pending, CARD.retained, CARD.tutorChange];

// Open to anyone: every tutor inactivated on a course of their project lands here; they assign it to someone in the TA or L&D wing.
export default function TaHeadReplacements() {
  const access = useTrackerAccess();

  return (
    <TrackerPage
      view={VIEWS.HEAD}
      title={'Tutor Replacements — TA Head'}
      cards={CARDS}
      cardRows={2}
      team={access.team}
    />
  );
}
